__webpack_require__.p = "/faq-accordion-card/";